<template src="./templates/index.html" />

<script type="text/ecmascript-6">
import ValidationsList from 'src/pages/submissions/components/validation-list/'
import SubmissionComputed from 'src/pages/submissions/script/common.computed'
import Methods from 'src/pages/submissions/components/validator/script/methods'
import FouGroup from 'components/layout/fou-group/'
import {mapActions} from 'vuex'

export default {
  name: 'Validator',

  components: {
    ...ValidationsList,
    FouGroup
  },

  props: {
    optimist: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      validations: []
    }
  },


  computed: {
    ...SubmissionComputed,
    dubiousValidations() {
      return this.validations.filter(v => v.errorLevel)
    },
    validationList() {
      return this.optimist ? this.dubiousValidations : this.validations
    },
    validationLevel() {
      return this.validations.some(v => v.errorLevel === 'ERROR') ? 'ERROR' : 'WARN'
    }
  },

  watch: {
    validationList: {
      handler() {
        this.$emit('error-on-font', this.validationList.some(error => error.errorLevel === 'ERROR'))
        this.updateFontValidationError( this.validationList.some(error => error.errorLevel === 'ERROR'))
      },
      deep: true,
      immediate: true
    }
  },

  created() {
    this.setValidations()
    this.$events?.$on('submission:results:update', this.setValidations)
  },

  beforeUnmount() {
    this.$events.$off('submission:results:update', this.setValidations)
  },

  methods: {
    ...Methods,
    ...mapActions('submissions', ['updateFontValidationError']),
  }
}
</script>

<style src="./stylesheets/index.scss" lang="scss" module></style>
